(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["able-react"] = factory();
	else
		root["able-react"] = factory();
})(this, () => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 431:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ src_Picto)
});

// UNUSED EXPORTS: Accessories104, Accessories56, AccountsPayments104, AccountsPayments56, AdaptiveCollaborationCloud104, AdaptiveCollaborationCloud56, AdaptiveCollaborationPhone104, AdaptiveCollaborationPhone56, AdaptiveNetworksCentre104, AdaptiveNetworksCentre56, Add104, Add56, AddPhone104, AddPhone56, AdultFemale104, AdultFemale56, AdultMale104, AdultMale56, AndrogynousPersonOne104, AndrogynousPersonOne56, AndrogynousPersonTwo104, AndrogynousPersonTwo56, AppMyTelstra104, AppMyTelstra56, Appointment104, Appointment56, Arts104, Arts56, Australia104, Australia56, AvatarAdultFemale104, AvatarAdultFemale56, AvatarAdultMale104, AvatarAdultMale56, AvatarAndrogynousPersonOne104, AvatarAndrogynousPersonOne56, AvatarAndrogynousPersonTwo104, AvatarAndrogynousPersonTwo56, AvatarBaby104, AvatarBaby56, AvatarBaldMale104, AvatarBaldMale56, AvatarBaldManBeard104, AvatarBaldManBeard56, AvatarBaldManGlasses104, AvatarBaldManGlasses56, AvatarBeardMan104, AvatarBeardMan56, AvatarBoy104, AvatarBoy56, AvatarCat104, AvatarCat56, AvatarChild104, AvatarChild56, AvatarDoctorFemale104, AvatarDoctorFemale56, AvatarDog104, AvatarDog56, AvatarElderlyFemale104, AvatarElderlyFemale56, AvatarElderlyMale104, AvatarElderlyMan56, AvatarFemaleOveralls104, AvatarFemaleOveralls56, AvatarFirstNationsFemale104, AvatarFirstNationsFemale56, AvatarFirstNationsMale104, AvatarFirstNationsMale56, AvatarGirlPigTails104, AvatarGirlPigTails56, AvatarHatAndSunglasses104, AvatarHatAndSunglasses56, AvatarHijabFemale104, AvatarHijabFemale56, AvatarLady104, AvatarLady56, AvatarLadyGlasses104, AvatarLadyGlasses56, AvatarLonghairGirl104, AvatarLonghairGirl56, AvatarMiddleAgeFemale104, AvatarMiddleAgeFemale56, AvatarMiddleAgeMan104, AvatarMiddleAgeMan56, AvatarMoustacheMan104, AvatarMoustacheMan56, AvatarOutbackMale104, AvatarOutbackMale56, AvatarPerson104, AvatarPerson56, AvatarPersonAfro104, AvatarPersonAfro56, AvatarPersonBusiness104, AvatarPersonBusiness56, AvatarSunSmartMale104, AvatarSunSmartMale56, AvatarTeen104, AvatarTeen56, AvatarTeenFemale104, AvatarTeenFemale56, AvatarTeenGirl104, AvatarTeenGirl56, AvatarTelstraHardHat104, AvatarTelstraHardHat56, AvatarTurbanMale104, AvatarTurbanMale56, AvatarYoungAdultMale104, AvatarYoungAdultMale56, Baby104, Baby56, BaldMale104, BaldMale56, Bank104, Bank56, BillEmails104, BillEmails56, BillOverview104, BillOverview56, BillPaid104, BillPaid56, BroadbandEnterpriseSim104, BroadbandEnterpriseSim56, BroadbandHome104, BroadbandHome56, BroadbandMobile104, BroadbandMobile56, BroadbandMobileSim104, BroadbandMobileSim56, Building104, Building56, Bundles104, Bundles56, Bus104, Bus56, BusinessIdeas104, BusinessIdeas56, BusinessOperation104, BusinessOperation56, BusinessSoftware104, BusinessSoftware56, BusinessStrategy104, BusinessStrategy56, Calendar104, Calendar56, CardAdded104, CardAdded56, Cart104, Cart56, Cat104, Cat56, ChangePlan104, ChangePlan56, Charger104, Charger56, Chat104, Chat56, Child104, Child56, ClickAndCollect104, ClickAndCollect56, Clock104, Clock56, Compare104, Compare56, CoverageMap104, CoverageMap56, CoverageMobile104, CoverageMobile56, CoverageNetwork104, CoverageNetwork56, Cyclone104, Cyclone56, CycloneandStorms104, CycloneandStorms56, DataPacks104, DataPacks56, DataPool104, DataPool56, Deal104, Deal56, Delivery104, Delivery56, DeviceLocator104, DeviceLocator56, DeviceProtect104, DeviceProtect56, Devices104, Devices56, Disruptions104, Disruptions56, DoctorFemale104, DoctorFemale56, Document104, Document56, Dog104, Dog56, Download104, Download56, DownloadDoc104, DownloadDoc56, DriverLicence104, DriverLicence56, ESIM104, ESIM56, EarnPoints104, EarnPoints56, Earthquake104, Earthquake56, Edit104, Edit56, ElderlyFemale104, ElderlyFemale56, ElderlyMale104, ElderyMale56, Electricity104, Electricity56, ElectricityMeter104, ElectricityMeter56, EmptyStateBox104, EmptyStateBox56, EmptyStateTray104, EmptyStateTray56, Energy104, Energy56, EnergySolar104, EnergySolar56, EnergyWind104, EnergyWind56, EnterpriseCloud104, EnterpriseCloud56, Entertainment104, Entertainment56, EntertainmentPackages104, EntertainmentPackages56, Error104, Error56, ErrorServer104, ErrorServer56, FailedConnection104, FailedConnection56, Feedback104, Feedback56, FieldExecution104, FieldExecution56, Fire104, Fire56, FirstNationsFemale104, FirstNationsFemale56, FirstNationsMale104, FirstNationsMale56, Floods104, Floods56, Foxtel104, Foxtel56, Gaming104, Gaming56, Gas104, Gas56, GasMeter104, GasMeter56, GetInTouch104, GetInTouch56, Gift104, Gift56, GlobalMapMarker104, GlobalMapMarker56, GlobalNetworks104, GlobalNetworks56, GreenEnergy104, GreenEnergy56, Headphones104, Headphones56, Help104, Help56, HijabFemale104, HijabFemale56, History104, History56, Home104, Home56, IDGeneric104, IDGeneric56, IOT104, IOT56, IOTUpdate104, IOTUpdate56, IRCallingPack104, IRCallingPack56, Information104, Information56, Installation104, Installation56, InternationalCalls104, InternationalCalls56, InternationalMobileCalls104, InternationalMobileCalls56, Internet104, Internet56, InternetCalls104, InternetCalls56, InternetExtras104, InternetExtras56, InternetMobileCalls104, InternetMobileCalls56, InternetOptimiser104, InternetOptimiser56, Landline104, Landline56, Laptop104, Laptop56, LatencyOptimiser104, LatencyOptimiser56, LatestInvoices104, LatestInvoices56, Legal104, Legal56, MBBRoaming104, MBBRoaming56, MIddleAgeFemale56, Mail104, Mail56, ManageDevicesAccess104, ManageDevicesAccess56, ManageDevicesEnrolled104, ManageDevicesEnrolled56, ManageDevicesLock104, ManageDevicesLock56, ManageDevicesMonitor104, ManageDevicesMonitor56, ManageDevicesSettings104, ManageDevicesSettings56, ManageDevicesShield104, ManageDevicesShield56, ManageDevicesUnenrolled104, ManageDevicesUnenrolled56, MapMarker104, MapMarker56, Membership104, Membership56, MiddleAgeFemale104, MiddleAgeMale104, MiddleAgeMale56, Mobile104, Mobile56, MobileAccelerator104, MobileAccelerator56, MobileSim104, MobileSim56, MoveHouse104, MoveHouse56, Movies104, Movies56, Music104, Music56, NBN104, NBN56, NBNHealth104, NBNHealth56, NetworkSpeed104, NetworkSpeed56, NewMobile104, NewMobile56, News104, News56, NoBills104, NoBills56, NotificationCall104, NotificationCall56, NotificationCentre104, NotificationCentre56, NotificationEmail104, NotificationEmail56, NotificationMessage104, NotificationMessage56, NotificationReminder104, NotificationReminder56, Notifications104, Notifications56, OneNumber104, OneNumber56, OutbackMale104, OutbackMale56, PassportAustralia104, PassportAustralia56, PassportInternational104, PassportInternational56, PayPhone104, PayPhone56, Payment104, Payment56, PaymentCalendar104, PaymentCalendar56, PaymentHelp104, PaymentHelp56, PaymentPlan104, PaymentPlan56, PeaceOfMind104, PeaceOfMind56, Perfect104, Perfect56, Phone104, Phone56, PhoneCase104, PhoneCase56, PhoneSound104, PhoneSound56, Picto4G104, Picto4G56, Picto4GX104, Picto4GX56, Picto5G104, Picto5G56, Pin104, Pin56, Placeholder104, Placeholder56, PoleInspection104, PoleInspection56, PortMobile104, PortMobile56, PortPhone104, PortPhone56, PortSIM104, PortSIM56, PostPaid104, PostPaid56, PrePaid104, PrePaid56, Preferences104, Preferences56, PriorityAssistance104, PriorityAssistance56, Profile104, Profile56, ProfileCompletion104, ProfileCompletion56, PromoCombined104, PromoCombined56, PromoData104, PromoData56, PromoDiscount104, PromoDiscount56, RaisedSurface104, RaisedSurface56, Receipt104, Receipt56, RecurringPayment104, RecurringPayment56, RedeemPoints104, RedeemPoints56, Rewards104, Rewards56, Roaming104, Roaming56, RoamingOn104, RoamingOn56, SIM104, SIM56, SMS104, SMS56, Satellite104, Satellite56, Search104, Search56, Security104, Security56, SecurityHome104, SecurityHome56, SecurityInternet104, SecurityInternet56, SecurityMobile104, SecurityMobile56, SendOldPhone104, SendOldPhone56, Services104, Services56, Settings104, Settings56, Share104, Share56, SharedWiFi104, SharedWiFi56, Shop104, Shop56, Signin104, Signin56, SmartHome104, SmartHome56, SmartWiFiBooster104, SmartWiFiBooster56, SomethingWentWrong104, SomethingWentWrong56, SpeedOptimiser104, SpeedOptimiser56, Sporting104, Sporting56, StarlinkSatellite104, StarlinkSatellite56, Store104, Store56, StoreAddress104, StoreAddress56, StoreClock104, StoreClock56, StoreSuccess104, StoreSuccess56, Storm104, Storm56, Success104, Success56, SunSmartMale104, SunSmartMale56, SupportPhone104, SupportPhone56, Swipe104, Swipe56, SwitchOff104, SwitchOff56, SwitchOn104, SwitchOn56, TV104, TV56, Tablet104, Tablet56, TabletSim104, TabletSim56, Technician104, Technician56, Teen104, Teen56, TeenFemale104, TeenFemale56, Telstra104, Telstra56, TelstraAir104, TelstraAir56, TelstraConnect104, TelstraConnect56, TelstraLocator104, TelstraLocator56, TelstraPlus104, TelstraPlus56, TelstraTV104, TelstraTV56, Ticket104, Ticket56, TrackOrder104, TrackOrder56, TradeIn104, TradeIn56, Train104, Train56, TransferRequest104, TransferRequest56, Translate104, Translate56, Troubleshoot104, Troubleshoot56, TruckFire104, TruckFire56, TurbanMale104, TurbanMale56, UnderseaCable104, UnderseaCable56, UnderseaCableNetwork104, UnderseaCableNetwork56, UnifiedComms104, UnifiedComms56, Unlimited104, Unlimited56, Upgrade104, Upgrade56, UploadDoc104, UploadDoc56, VIP104, VIP56, Video104, Video56, Warning104, Warning56, Watch104, Watch56, WeCare104, WeCare56, WhiteLabelAboutApp104, WhiteLabelAboutApp56, WhiteLabelAccountsPayments104, WhiteLabelAccountsPayments56, WhiteLabelBank104, WhiteLabelBank56, WhiteLabelBillOverview104, WhiteLabelBillOverview56, WhiteLabelBillPaid104, WhiteLabelBillPaid56, WhiteLabelBroadbandMobile104, WhiteLabelBroadbandMobile56, WhiteLabelCardAdded104, WhiteLabelCardAdded56, WhiteLabelChangePlan104, WhiteLabelChangePlan56, WhiteLabelChat104, WhiteLabelChat56, WhiteLabelDataPacks104, WhiteLabelDataPacks56, WhiteLabelDataPool104, WhiteLabelDataPool56, WhiteLabelDelivery104, WhiteLabelDelivery56, WhiteLabelDownload104, WhiteLabelDownload56, WhiteLabelESIM104, WhiteLabelESIM56, WhiteLabelEmptyStateBox104, WhiteLabelEmptyStateBox56, WhiteLabelError104, WhiteLabelError56, WhiteLabelFailedConnection104, WhiteLabelFailedConnection56, WhiteLabelFeedback104, WhiteLabelFeedback56, WhiteLabelGift104, WhiteLabelGift56, WhiteLabelHelp104, WhiteLabelHelp56, WhiteLabelInformation104, WhiteLabelInformation56, WhiteLabelInstallation104, WhiteLabelInstallation56, WhiteLabelInternationalCalls104, WhiteLabelInternationalCalls56, WhiteLabelInternationalMobileCall104, WhiteLabelInternationalMobileCall56, WhiteLabelInternet104, WhiteLabelInternet56, WhiteLabelMail104, WhiteLabelMail56, WhiteLabelMobile104, WhiteLabelMobile56, WhiteLabelMobileAndTablet104, WhiteLabelMobileAndTablet56, WhiteLabelNetworkSpeed104, WhiteLabelNetworkSpeed56, WhiteLabelPayment104, WhiteLabelPayment56, WhiteLabelPaymentCalendar104, WhiteLabelPaymentCalendar56, WhiteLabelPaymentHelp104, WhiteLabelPaymentHelp56, WhiteLabelPin104, WhiteLabelPin56, WhiteLabelPlaceholder104, WhiteLabelPlaceholder56, WhiteLabelPostPaid104, WhiteLabelPostPaid56, WhiteLabelPrePaid104, WhiteLabelPrePaid56, WhiteLabelProfile104, WhiteLabelProfile56, WhiteLabelPromoCombined104, WhiteLabelPromoCombined56, WhiteLabelPromoData104, WhiteLabelPromoData56, WhiteLabelPromoDiscount104, WhiteLabelPromoDiscount56, WhiteLabelReceipt104, WhiteLabelReceipt56, WhiteLabelRecurringPayment104, WhiteLabelRecurringPayment56, WhiteLabelRoaming104, WhiteLabelRoaming56, WhiteLabelSMS104, WhiteLabelSMS56, WhiteLabelSecurity104, WhiteLabelSecurity56, WhiteLabelServices104, WhiteLabelServices56, WhiteLabelSettings104, WhiteLabelSettings56, WhiteLabelSignIn104, WhiteLabelSignIn56, WhiteLabelSomethingWentWrong104, WhiteLabelSomethingWentWrong56, WhiteLabelSuccess104, WhiteLabelSuccess56, WhiteLabelSupportPhone104, WhiteLabelSupportPhone56, WhiteLabelTechnician104, WhiteLabelTechnician56, WhiteLabelTrackOrder104, WhiteLabelTrackOrder56, WhiteLabelWarning104, WhiteLabelWarning56, WhiteLabelWeCare104, WhiteLabelWeCare56, WhiteLabelWiFi104, WhiteLabelWiFi56, WiFi104, WiFi56, WiFiBooster104, WiFiBooster56, Window104, Window56, YoungAdultMale104, YoungAdultMale56

// EXTERNAL MODULE: external "@babel/runtime/helpers/defineProperty"
var defineProperty_ = __webpack_require__(1116);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty_);
// EXTERNAL MODULE: external "@babel/runtime/helpers/objectWithoutProperties"
var objectWithoutProperties_ = __webpack_require__(2462);
var objectWithoutProperties_default = /*#__PURE__*/__webpack_require__.n(objectWithoutProperties_);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(6942);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(2015);
// EXTERNAL MODULE: external "react/jsx-runtime"
var jsx_runtime_ = __webpack_require__(8732);
;// ./src/Picto/Picto.tsx


var _excluded = ["className", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }



/**
 *
 * Illustrations help convey complex ideas in a simple way.
 * They should be meaningful and reflect a user's context and emotional state.
 * We use them to make technical information feel more human, and add some personality to the way we communicate.
 *
 * [View the Picto documentation on Confluence](https://confluence.tools.telstra.com/display/DCSYS/Pictograms+and+Illustrations)
 *
 * @version 1.0.0
 */

function Picto(props) {
  var className = props.className,
    children = props.children,
    other = objectWithoutProperties_default()(props, _excluded);
  var classes = classnames_default()('able-picto', className);
  var childProps = _objectSpread({
    className: classes,
    focusable: 'false',
    'aria-hidden': 'true'
  }, other);
  var SelectedPictogram = function SelectedPictogram() {
    return /*#__PURE__*/(0,external_react_.cloneElement)(children, childProps);
  };
  return /*#__PURE__*/(0,jsx_runtime_.jsx)(SelectedPictogram, {});
}
/* harmony default export */ const Picto_Picto = (Picto);
// EXTERNAL MODULE: ./src/Picto/Picto.scss
var src_Picto_Picto = __webpack_require__(493);
;// ./src/Picto/index.ts



/* harmony default export */ const src_Picto = (Picto_Picto);

/***/ }),

/***/ 493:
/***/ (() => {



/***/ }),

/***/ 1103:
/***/ (() => {



/***/ }),

/***/ 1116:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 1217:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export iconVersion */
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1116);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2462);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6942);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8732);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__);


var _excluded = ["className", "developmentUrl", "icon", "screenReaderContent", "size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }


var iconVersion = 12;

/**
 * Icons are symbols that provide visual context and communicate function
 * or intent in a universal way.
 *
 * Available icon names are listed at https://confluence.tools.telstra.com/display/DCSYS/Icons
 *
 * @version 1.0.0
 */
function Icon(props) {
  var className = props.className,
    developmentUrl = props.developmentUrl,
    icon = props.icon,
    screenReaderContent = props.screenReaderContent,
    _props$size = props.size,
    size = _props$size === void 0 ? '24' : _props$size,
    other = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1___default()(props, _excluded);
  var href = developmentUrl || "//www.telstra.com.au/content/dam/tcom/able/able-sprites.svg?v".concat(iconVersion);
  var classes = classnames__WEBPACK_IMPORTED_MODULE_2___default()('able-icon', "able-icon--".concat(size), className || null);
  var deprecatedIcons = {
    Visibility: ['ToggleOff, ToggleOn'],
    ScanBarcode: ['Scan']
  };
  var replacementIcons = icon;
  if (deprecatedIcons.hasOwnProperty(icon)) {
    replacementIcons = deprecatedIcons[icon].join(' ');
    console.warn("Icon ".concat(icon, " is deprecated, and will be removed in July 2024. Use '").concat(replacementIcons, "' instead."));
  }
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("svg", _objectSpread(_objectSpread(_objectSpread({
    className: classes,
    role: "img",
    "aria-hidden": !screenReaderContent ? 'true' : 'false'
  }, screenReaderContent && {
    'aria-label': screenReaderContent
  }), {}, {
    focusable: "false"
  }, other), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("use", {
      href: "".concat(href, "#").concat(icon)
    })
  }));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Icon);

/***/ }),

/***/ 2015:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ 2462:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/objectWithoutProperties");

/***/ }),

/***/ 5133:
/***/ (() => {



/***/ }),

/***/ 6168:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1217);
/* harmony import */ var _Icon_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5133);
/* harmony import */ var _Icon_scss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Icon_scss__WEBPACK_IMPORTED_MODULE_0__);



/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_Icon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A);

/***/ }),

/***/ 6942:
/***/ ((module, exports) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 8732:
/***/ ((module) => {

"use strict";
module.exports = require("react/jsx-runtime");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  ActionListItem: () => (/* reexport */ ActionList_ActionListItem),
  combineAriaDescribedByIds: () => (/* reexport */ combineAriaDescribedByIds),
  "default": () => (/* binding */ src_ActionList)
});

// EXTERNAL MODULE: external "@babel/runtime/helpers/defineProperty"
var defineProperty_ = __webpack_require__(1116);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty_);
// EXTERNAL MODULE: external "@babel/runtime/helpers/objectWithoutProperties"
var objectWithoutProperties_ = __webpack_require__(2462);
var objectWithoutProperties_default = /*#__PURE__*/__webpack_require__.n(objectWithoutProperties_);
// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(2015);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(6942);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: external "react/jsx-runtime"
var jsx_runtime_ = __webpack_require__(8732);
;// ./src/ActionList/ActionList.tsx


var _excluded = ["children", "className", "topDivider", "variant"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }



/**
 *
 * ActionList is used to feature a list of navigation actions in the body of a page.
 *
 * @link https://confluence.tools.telstra.com/display/DCSYS/Action+List
 * @version 1.0.0
 */
var ActionList = function ActionList(props) {
  var children = props.children,
    className = props.className,
    topDivider = props.topDivider,
    variant = props.variant,
    other = objectWithoutProperties_default()(props, _excluded);
  var classes = classnames_default()("able-ActionList--".concat(variant).concat(topDivider ? '--top-divider' : ''), className || null);
  var childrenWithProps = external_react_.Children.map(children, function (child) {
    return /*#__PURE__*/(0,external_react_.cloneElement)(child, {
      variantPassedFromParent: variant
    });
  });
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("ul", _objectSpread(_objectSpread({
    className: classes
  }, other), {}, {
    children: childrenWithProps
  }));
};
ActionList.displayName = 'ActionList';
/* harmony default export */ const ActionList_ActionList = (ActionList);
;// ./src/_shared/_partials/ArrowIcon/index.tsx

/**
 *
 * ArrowIcon is a component partial used in some interaction patterns.
 *
 * @link https://confluence.tools.telstra.com/display/DCSYS/Action+List
 * @param {string} className custom classname
 * @version 1.0.0
 */

var ArrowIcon = function ArrowIcon(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", {
    className: className,
    version: "1.1",
    "aria-hidden": "true",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M21.28 11.47 16 6.19a.75.75 0 0 0-1.06 0 .75.75 0 0 0 0 1.06L19.69 12l-4.75 4.75A.75.75 0 1 0 16 17.81l5.28-5.28a.75.75 0 0 0 0-1.06Z"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
      className: "arr02",
      x: "5.5",
      y: "11.25",
      width: "15",
      height: "1.5",
      rx: ".75"
    })]
  });
};
/* harmony default export */ const _partials_ArrowIcon = (ArrowIcon);
;// external "react-router-dom"
const external_react_router_dom_namespaceObject = require("react-router-dom");
;// ./src/_shared/_partials/InteractiveElement/index.tsx


var InteractiveElement_excluded = ["children", "className", "element", "elementRef", "events", "externalSite", "opensNewTab", "href", "type", "to", "state", "ariaDisabled"];
function InteractiveElement_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function InteractiveElement_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? InteractiveElement_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : InteractiveElement_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }


/**
 * InteractiveElement is a component partial which can render anchors, buttons, React Links & NavLink
 *
 * @link https://confluence.tools.telstra.com/display/DCSYS/Action+List
 * @version 1.0.0
 */

function InteractiveElement(props) {
  var children = props.children,
    className = props.className,
    element = props.element,
    elementRef = props.elementRef,
    events = props.events,
    _props$externalSite = props.externalSite,
    externalSite = _props$externalSite === void 0 ? false : _props$externalSite,
    _props$opensNewTab = props.opensNewTab,
    opensNewTab = _props$opensNewTab === void 0 ? false : _props$opensNewTab,
    href = props.href,
    _props$type = props.type,
    type = _props$type === void 0 ? 'button' : _props$type,
    to = props.to,
    state = props.state,
    ariaDisabled = props.ariaDisabled,
    other = objectWithoutProperties_default()(props, InteractiveElement_excluded);
  var filteredOpensNewTab = opensNewTab || externalSite;
  if (!filteredOpensNewTab) {
    if (events) {
      if (events.rel) {
        delete events.rel;
      }
      if (events.target && events.target === '_blank') {
        delete events.target;
      }
    }
  }
  var filteredTarget = element && element !== 'button' && filteredOpensNewTab ? '_blank' : undefined;
  var elementProps = InteractiveElement_objectSpread(InteractiveElement_objectSpread(InteractiveElement_objectSpread({}, events), other), {}, {
    className: className,
    ref: elementRef,
    'aria-disabled': ariaDisabled,
    target: filteredTarget,
    rel: filteredOpensNewTab ? 'noopener noreferrer' : undefined
  });
  var targetURL = href || to || '/';
  if (element === 'a') {
    return /*#__PURE__*/(0,jsx_runtime_.jsx)("a", InteractiveElement_objectSpread(InteractiveElement_objectSpread({
      href: targetURL
    }, elementProps), {}, {
      children: children
    }));
  }
  if (element === 'Link') {
    return /*#__PURE__*/(0,jsx_runtime_.jsx)(external_react_router_dom_namespaceObject.Link, InteractiveElement_objectSpread(InteractiveElement_objectSpread({
      to: targetURL
    }, elementProps), {}, {
      state: state,
      children: children
    }));
  }
  if (element === 'NavLink') {
    return /*#__PURE__*/(0,jsx_runtime_.jsx)(external_react_router_dom_namespaceObject.NavLink, InteractiveElement_objectSpread(InteractiveElement_objectSpread({
      to: targetURL
    }, elementProps), {}, {
      children: children
    }));
  }
  return (
    /*#__PURE__*/
    // https://github.com/yannickcr/eslint-plugin-react/issues/1555
    // eslint-disable-next-line react/button-has-type
    (0,jsx_runtime_.jsx)("button", InteractiveElement_objectSpread(InteractiveElement_objectSpread({
      type: type
    }, elementProps), {}, {
      children: children
    }))
  );
}
/* harmony default export */ const _partials_InteractiveElement = (InteractiveElement);
// EXTERNAL MODULE: ./src/Icon/index.ts
var Icon = __webpack_require__(6168);
// EXTERNAL MODULE: ./src/Picto/index.ts + 1 modules
var src_Picto = __webpack_require__(431);
;// ./src/_shared/_partials/OpensNewTabSrOnlySpan/index.tsx

/**
 *
 * OpensNewTabSrOnlySpan is a component partial used by ActionButton and ActionListItem
 *
 */

var OpensNewTabSrOnlySpan = function OpensNewTabSrOnlySpan() {
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("span", {
    className: "able-sr-only",
    children: ", opens new tab"
  });
};
/* harmony default export */ const _partials_OpensNewTabSrOnlySpan = (OpensNewTabSrOnlySpan);
;// ./src/_shared/_helpers/generateAriaImageLabelling.tsx
var generateAriaImageLabelling = function generateAriaImageLabelling(imageAriaLabel, imageAriaLabelId, returnAltText) {
  if (imageAriaLabel && returnAltText) {
    return {
      id: imageAriaLabelId,
      alt: imageAriaLabel
    };
  }
  if (!imageAriaLabel && returnAltText) {
    return {
      alt: ''
    };
  }
  if (imageAriaLabel) {
    return {
      'aria-label': imageAriaLabel,
      id: imageAriaLabelId,
      'aria-hidden': false
    };
  }
  return undefined;
};
;// ./src/ActionList/ActionListItem.tsx


var ActionListItem_excluded = ["className", "description", "developmentUrl", "element", "elementRef", "events", "externalSite", "href", "id", "icon", "label", "logoTilePath", "logoTilePathOnErrorCallback", "Picto", "imageAriaLabel", "describedById", "to", "variantPassedFromParent", "opensNewTab", "state"];
function ActionListItem_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ActionListItem_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ActionListItem_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ActionListItem_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }








var combineAriaDescribedByIds = function combineAriaDescribedByIds(ids) {
  var allIds = [];
  var describedByIds = null;
  ids.forEach(function (id) {
    if (id) {
      allIds.push(id);
    }
  });
  var combinedIds = allIds.join(' ');
  if (combinedIds.length) {
    describedByIds = {
      'aria-describedby': combinedIds
    };
  }
  return describedByIds;
};

/**
 * ActionListItem is to be used as a child for ActionList
 *
 * @version 1.0.0
 */
var ActionListItem = function ActionListItem(props) {
  var className = props.className,
    description = props.description,
    developmentUrl = props.developmentUrl,
    element = props.element,
    elementRef = props.elementRef,
    events = props.events,
    externalSite = props.externalSite,
    href = props.href,
    id = props.id,
    icon = props.icon,
    label = props.label,
    logoTilePath = props.logoTilePath,
    logoTilePathOnErrorCallback = props.logoTilePathOnErrorCallback,
    Picto = props.Picto,
    imageAriaLabel = props.imageAriaLabel,
    describedById = props.describedById,
    to = props.to,
    variantPassedFromParent = props.variantPassedFromParent,
    _props$opensNewTab = props.opensNewTab,
    opensNewTab = _props$opensNewTab === void 0 ? false : _props$opensNewTab,
    state = props.state,
    other = objectWithoutProperties_default()(props, ActionListItem_excluded);
  var filteredProps = {
    filteredDescription: variantPassedFromParent !== 'Simple' ? description : null,
    filteredIcon: variantPassedFromParent !== 'Hero' ? icon : null,
    filteredPicto: variantPassedFromParent === 'Hero' ? Picto : null,
    filteredLogoTilePath: variantPassedFromParent === 'Hero' ? logoTilePath : null,
    filteredLogoTilePathOnErrorCallback: variantPassedFromParent === 'Hero' ? logoTilePathOnErrorCallback : null,
    filteredOpensNewTab: element.toLowerCase() !== 'button' && (opensNewTab || externalSite)
  };
  var filteredDescription = filteredProps.filteredDescription,
    filteredIcon = filteredProps.filteredIcon,
    filteredPicto = filteredProps.filteredPicto,
    filteredLogoTilePath = filteredProps.filteredLogoTilePath,
    filteredLogoTilePathOnErrorCallback = filteredProps.filteredLogoTilePathOnErrorCallback,
    filteredOpensNewTab = filteredProps.filteredOpensNewTab;
  var presetImageAriaLabelId = (0,external_react_.useId)();
  var presetDescriptionId = (0,external_react_.useId)();
  var imageAriaLabelId = imageAriaLabel ? "labelledImageId_".concat(presetImageAriaLabelId) : '';
  var descriptionId = filteredDescription ? "desc".concat(presetDescriptionId) : '';
  var interactiveElementProps = {
    element: element,
    elementRef: elementRef,
    events: events,
    href: href,
    id: id,
    to: to,
    state: state,
    opensNewTab: filteredOpensNewTab
  };
  var imageLabelling = generateAriaImageLabelling(imageAriaLabel, imageAriaLabelId);
  var idsForAriaDescribedBy = combineAriaDescribedByIds([imageAriaLabelId, describedById, descriptionId]);
  var imageTypeToRender = function imageTypeToRender() {
    if (filteredIcon) {
      return /*#__PURE__*/(0,jsx_runtime_.jsx)(Icon["default"], ActionListItem_objectSpread({
        icon: filteredIcon,
        developmentUrl: developmentUrl
      }, imageLabelling));
    }
    if (filteredPicto) {
      return /*#__PURE__*/(0,jsx_runtime_.jsx)(src_Picto["default"], ActionListItem_objectSpread(ActionListItem_objectSpread({}, imageLabelling), {}, {
        children: filteredPicto
      }));
    }
    if (filteredLogoTilePath) {
      return /*#__PURE__*/(0,jsx_runtime_.jsx)("img", ActionListItem_objectSpread(ActionListItem_objectSpread({
        src: filteredLogoTilePath,
        alt: ""
      }, generateAriaImageLabelling(imageAriaLabel, imageAriaLabelId, true)), {}, {
        onError: function onError() {
          if (typeof filteredLogoTilePathOnErrorCallback === 'function') {
            filteredLogoTilePathOnErrorCallback();
          }
        }
      }));
    }
    return null;
  };
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("li", ActionListItem_objectSpread(ActionListItem_objectSpread({
    className: className
  }, other), {}, {
    children: [imageTypeToRender(), /*#__PURE__*/(0,jsx_runtime_.jsxs)("div", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)(_partials_InteractiveElement, ActionListItem_objectSpread(ActionListItem_objectSpread(ActionListItem_objectSpread({}, interactiveElementProps), {}, {
        type: element === 'button' ? 'button' : undefined
      }, idsForAriaDescribedBy), {}, {
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("span", {
          "aria-hidden": "true"
        }), label, filteredOpensNewTab ? /*#__PURE__*/(0,jsx_runtime_.jsx)(_partials_OpensNewTabSrOnlySpan, {}) : '']
      })), filteredDescription ? /*#__PURE__*/(0,jsx_runtime_.jsx)("p", {
        id: descriptionId,
        children: filteredDescription
      }) : '']
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)(_partials_ArrowIcon, {
      className: "arrow"
    })]
  }));
};
/* harmony default export */ const ActionList_ActionListItem = (ActionListItem);
// EXTERNAL MODULE: ./src/ActionList/ActionList.scss
var src_ActionList_ActionList = __webpack_require__(1103);
;// ./src/ActionList/index.ts




/* harmony default export */ const src_ActionList = (ActionList_ActionList);
})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});